import { MBText } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { API } from '@shared/types/api';
import { Styles } from './styles';

export const MAX_SHOWN_AFTER_TRUNCATION = 4;
export const MAX_BEFORE_TRUNCATION = 20;

interface MBStackedUsersProps {
  /*
        Array of users to display.
    */
  users: API.ShortUserFragment[];

  /*
        If set, the stacked images will be smaller
    */
  small?: boolean;

  /*
        If set, the total user count (length of images) will be
        shown to the right of the stacked images.
    */
  isCountVisible?: boolean;
}

/*
    A component to show stacked users. The users are not really stacked,
    but show up just next to each other in a row.
*/
export function MBStackedUsers({ users, small, isCountVisible }: MBStackedUsersProps) {
  const isTruncated = users.length > MAX_BEFORE_TRUNCATION;
  const usersToShow = isTruncated ? users.slice(0, MAX_SHOWN_AFTER_TRUNCATION) : users;

  return (
    <View row="reverse" centerVertically shrinkWrap>
      {!!isCountVisible && (
        <MBText size="small" style={Styles.stackedUserCountText}>
          {users.length}
        </MBText>
      )}

      {usersToShow.map((user: API.ShortUserFragment, index: number) => (
        <MBUserImage
          key={index}
          user={user}
          size={small ? 'tiny' : 'small'}
          style={[
            !small && Styles.stackedUserImage,
            small && Styles.stackedUserImageSmall,
            // add negative overlap margin to all but the image to the left
            (!small || isTruncated) && index !== users.length - 1 && Styles.stackedUserOverlap,
          ]}
        />
      ))}
    </View>
  );
}
